import { getWorkloadScenarioType } from '../utils/getWorkloadScenarioType';
import { createUpdateScenarioSettingUrl } from '../utils/createUpdateScenarioSettingsUrl';
import { makePatchRequest } from 'owa-ows-gateway';
import {
    TimePanelSelectedViewRequestType,
    TimePanelSelectedViewType,
} from '../schema/ScenarioSettings/TimePanelSelectedView';
import { getOwaWorkload } from 'owa-workloads';
import { isSupportedWorkload } from '../utils/isSupportedWorkload';

export async function updateTimePanelSelectedViewService(
    selectedView: TimePanelSelectedViewType
): Promise<void> {
    const workload = getOwaWorkload();
    if (isSupportedWorkload(workload)) {
        const scenario = getWorkloadScenarioType(workload);
        const requestUrl = createUpdateScenarioSettingUrl(scenario, 'TimePanelSelectedView');
        const timePanelSelectedView: TimePanelSelectedViewRequestType = { ViewType: selectedView };
        await makePatchRequest(
            requestUrl,
            timePanelSelectedView,
            undefined /* correlationId */,
            undefined /* returnFullResponse */,
            undefined /* customHeaders */,
            true /* throwServiceError */,
            undefined /* isThrottled */
        );
    }
}
